<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :isShowApplyStateSelect="true"
    applyStateSelectLabel="审核状态"
    :is-show-administrator-select="isAdministrator"
    administrator-select-label="申请人员"
    :is-show-quick-time-tab="true"
    quick-time-tab-label="申请日期"
    :is-show-student-select="true"
    :is-show-store-select="isAdministrator"
    :is-multiple-store="true"
    :has-private-store="true"
    store-select-label="申请门店"
    student-select-label="所属学员"
    :push-list="RouteConfig.cardUpdateApplyList.push"
    :query-list="queryList"
  >
    <div class="table-filter-select" slot="header-item">
      <el-popover
        v-if="isAdministrator && list.length"
        placement="top"
        width="160"
        v-model="isShowPassAllTip"
      >
        <p>确认要通过全部申请吗？</p>
        <div style="text-align: right; margin: 0">
          <el-button size="mini" type="text" @click="isShowPassAllTip = false">返回</el-button>
          <el-button type="primary" size="mini" @click="handlePassAll">确认</el-button>
        </div>
        <el-button slot="reference" :loading="isPassingAll" type="primary" size="small">全部通过</el-button>
      </el-popover>
    </div>
    <v-column-time value="申请时间"/>
    <el-table-column label="申请人员" width="150" align="center">
      <template v-slot="{ row }">
        <v-avatar-nickname v-if="row.administrator_id" :value="row.admin_avatar" :nickname="row.admin_nickname" :is-center="false"/>
        <span v-else class="success-color">学员本人</span>
      </template>
    </el-table-column>
    <el-table-column
      v-if="isAdministrator"
      label="申请门店"
      width="100"
      align="center"
      prop="store_name"
    />
    <el-table-column label="申请操作" width="100" align="center">
      <template v-slot="{ row }">
        <template v-for="updateType in updateTypes">
          <template v-if="updateType.value === row.update_type">{{ updateType.name }}</template>
        </template>
      </template>
    </el-table-column>
    <el-table-column label="课卡 ID" width="100" align="center" prop="card_id"/>
    <el-table-column label="课卡名称" width="100" align="center" prop="old_card_name"/>
    <v-column-student label="所属学员" link-page-id="old_student_id"/>
    <el-table-column label="所补差价" width="100" align="center">
      <template v-slot="{ row }">
        <span>{{ row.update_payment | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="修改原因" width="250" align="center" prop="update_remark"/>
    <el-table-column label="审核状态" width="150" align="center" prop="updateState">
      <template v-slot="{ row }">
        <el-tag
          v-for="updateState in findApplyState(row.update_state)"
          :key="`ApplyStateTag${updateState.value}`"
          :type="updateState.tagType"
        >
          {{ updateState.name }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center" width="244">
      <template v-slot="{ row }">
        <v-list-button name="查看" icon="view" :to="RouteConfig.cardUpdateApplyDetail.to(row.id)"/>
        <template v-if="row.update_state === applyStates.review.value">
          <v-list-button
            v-if="isAdministrator"
            name="驳回"
            icon="reject"
            @click="handleReject(row)"
            :is-loading="isRejectingIds.includes(row.id)"
            :is-last="true"
            message="确定要驳回申请吗？"
          />

          <v-list-button
            v-else-if="row.update_type !== updateTypes.stop.value"
            name="撤销"
            icon="restore"
            @click="handleRevoke(row)"
            :is-loading="isRevokingIds.includes(row.id)"
            :is-last="true"
            message="确定要撤销申请吗？"
          />
        </template>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`apply-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-title border-bottom">
              <span>{{ v.add_time | timeToYmdHi }}</span>
              <span>{{ v.store_name }}</span>
            </div>
            <div class="divider"></div>
            <div class="list-item-detail">
              <span>申请人员</span>
              <span>{{ v.admin_nickname }}</span>
            </div>

            <div class="list-item-detail">
              <span>申请操作</span>
              <span v-for="updateType in updateTypes" :key="updateType.value">
                <template v-if="updateType.value === v.update_type">{{ updateType.name }}</template>
              </span>
            </div>

            <div class="list-item-detail">
              <span>修改原因</span>
              <span>{{ v.update_remark }}</span>
            </div>

            <div class="list-item-detail">
              <span>审核状态</span>
              <span
                v-for="updateState in findApplyState(v.update_state)"
                :key="`mobileApplyStateTag${updateState.value}`"
                :class="`${updateState.tagType}-color`"
              >
                {{ updateState.name }}
              </span>
            </div>

            <div class="list-item-button">
              <v-list-button name="查看" icon="view" :to="RouteConfig.cardUpdateApplyDetail.to(v.id)"/>

              <template v-if="v.update_state === applyStates.review.value">
                <v-list-button
                  v-if="!isAdministrator && v.update_type !== updateTypes.stop.value"
                  name="撤销"
                  icon="restore"
                  :is-loading="isRevokingIds.includes(v.id)"
                  :is-last="true"
                  message="确定要撤销申请吗？"
                  @click="handleRevoke(v)"
                />
              </template>
            </div>
          </div>

          <v-pagination
            :count="count"
            :page="queryList.page"
            :size="queryList.size"
            @page-change="handlePageChange"
          />
        </template>

        <v-empty :is-loading="isLoading" v-else>暂无修改申请</v-empty>
      </section>
    </template>

  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import updateTypes from '@/enums/cardUpdateTypes';
import { applyStates, findApplyState } from '@/enums/applyStates';
import { mapGetters } from 'vuex';
import { index, destroy } from '@/api/card-update-apply';
import { storeAll } from '@/api/card-update-record';
import { removeArrayItem } from '@/utils';
import { getLegalQueryList } from "@/utils/formats";

export default {
  name: RouteConfig.cardUpdateApplyList.name,
  data: () => ({
    RouteConfig,
    visible: false,
    count: 0,
    list: [],
    stores: [],
    queryList: {
      is_asc: 0,
      apply_states: [applyStates.review.value],
      page: 1,
      size: 10,
    },
    isLoading: false,
    isDetailLoading: false,
    isShowDialog: false,
    isShowPassAllTip: false,
    isPassingAll: false,
    isRevokingIds: [],
    isPassingIds: [],
    isRejectingIds: [],
    updateTypes,
    applyStates,
  }),
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdministrator',
      'userStoreId',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    findApplyState,
    refresh() {
      RouteConfig.cardUpdateApplyList.push(this.queryList);
    },

    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },

    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;

      getLegalQueryList(queryList, query);
      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },

    async handleRevoke({ id }) {
      this.isRevokingIds.push(id);
      const { isError } = await destroy(id);
      removeArrayItem(this.isRevokingIds, id);
      if (!isError) this.load();
    },

    async handlePassAll() {
      if (this.isPassingAll) return;

      this.isPassingAll = true;
      const { isError } = await storeAll();
      this.isPassingAll = false;
      this.isShowPassAllTip = false;
      if (isError) return;

      this.load();
    },

  },
};
</script>
